<!-- Main Sidebar Container -->

<aside id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme">
<div class="logo-container">
  <div class="system-title">DICOM画像管理システム</div>
  <a [routerLink]="['/',AppRoutes.DASHBOARD]">
  <div class="logo-text">
    <span class="logo-main">守</span>
    <span class="logo-sub">るん</span>
    <span class="logo-main">99</span>
  </div>

  <!-- <div class="logo-note">（※ロゴなどを配置）</div> -->
  </a>
  <div class="closebar">
<a href="javascript:void(0);"
            class="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none" (click)="toggleSidebarClose()">
            <i class="bx bx-chevron-left bx-sm align-middle"></i>
        </a>
  </div>

</div>


  <div class="menu-inner-shadow"></div>

  <ul class="menu-inner py-1">
    <!-- Dashboard -->
    <li class="menu-item">
      <a [routerLink]="['/',AppRoutes.DASHBOARD]"
          class="menu-link menu-toggle"
          [class.active]="selectedMenu === 'dashboard'"
          (click)="selectMenu('dashboard')">
        <i class="menu-icon tf-icons bx bx-home-circle"></i>
        <div data-i18n="Analytics">ダッシュボード</div>
      </a>
    </li>

    <!-- PRESCRIPTION ORDER SECTION -->
    <li class="menu-header small text-uppercase">
      <span class="menu-header-text">顧客管理</span>
    </li>

    <li class="menu-item">
      <a [routerLink]="[AppRoutes.DASHBOARD_CHILDREN.CUSTOMER_LIST]"
          class="menu-link menu-toggle"
          [class.active]="selectedMenu === 'customer-list'"
          (click)="selectMenu('customer-list')">
        <i class="menu-icon fa fa-id-card"></i>
        <div data-i18n="Basic"> 顧客一覧・ <br>レントゲン登録</div>
      </a>
    </li>


    <!-- MEDICINE SECTION -->
    <li class="menu-header small text-uppercase">
      <span class="menu-header-text">レントゲン管理</span>
    </li>

    <li class="menu-item">
      <a href="#" class="menu-link menu-toggle" [routerLink]="[AppRoutes.DASHBOARD_CHILDREN.XRAY_LIST]"
          [class.active]="selectedMenu === 'x-ray-list'"
       (click)="selectMenu('x-ray-list')">
        <i class="menu-icon fa fa-list-alt" aria-hidden="true"></i>
        <div data-i18n="Account Settings">レントゲン一覧</div>
      </a>
    </li>

    <!-- CUSTOMER SECTION -->
    <li class="menu-header small text-uppercase">
      <span class="menu-header-text">基本設定</span>
    </li>

    <li class="menu-item">
      <a
        [routerLink]="[AppRoutes.DASHBOARD_CHILDREN.BASIC_SETTING]"
        class="menu-link menu-toggle"
        [class.active]="selectedMenu === 'basic-setting'"
        (click)="selectMenu('basic-setting')">
        <i class="menu-icon fa fa-user-circle"></i>
        <div data-i18n="Basic">基本設定</div>
      </a>
    </li>

    <li class="menu-item">
      <a
        [routerLink]="['support-settings']"
        class="menu-link menu-toggle"
        [class.active]="selectedMenu === 'support-setting'"
        (click)="selectMenu('support-setting')">
         <img src="search.svg " alt="">
        <div data-i18n="Basic" style="margin-left: 12px;">サポート設定</div>
      </a>
    </li>





  </ul>
</aside>
